// extracted by mini-css-extract-plugin
export default {"myLayout":"Layout_myLayout__+6S1F"};